<div class="page-layout p-24 blank" style="padding-bottom: 80px !important;">
  @if (loading || savingCredentials) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }
  @if (!domainHasTicketlandiaAccount && !loading) {
    <div>
      <h2>{{'Credenziali Ticketlandia' | translate}}</h2>
      <p>{{'Per rivendere i tour presenti su Ticketlandia è necessario un account' | translate}}.</p>
      <div class='tourcms-account-form'>
        <form-viewer
          #ticketlandiaAuthFormViewer
          [formConfig]='ticketlandiaAuthFormConfig'
        ></form-viewer>
        <button mat-flat-button color='accent' [disabled]='savingCredentials' (click)='setTicketlandiaAccount()'>{{'Salva' | translate}}</button>
      </div>
    </div>
  }
  @if (domainHasTicketlandiaAccount && !loading) {
    <div>
      <h2>{{'Ticketlandia tours' | translate}}</h2>
      <h3>
        {{'Credito residuo:' | translate}} {{credit | currency:'EUR'}}
      </h3>
      <dataset-list
        datasetCode='ticketlandia_tours'
        tableStyle='style-1 selectable btn-outlined'
      ></dataset-list>
    </div>
  }
</div>
